import axios from "../../../config/axiosConfig";

export const listarEmpleadosPlanilla = (params) => axios.get("/api/planillas/empleados", { params });
export const prepararPapeleta = (idEmpleado) => axios.get(`/api/planillas/empleados/${idEmpleado}/papeleta`);
export const emitirPlanilla = (body) => axios.post("/api/planillas/emitir", body);
export const listarPagosEmpleado = (idEmpleado) => axios.get(`/api/planillas/empleados/${idEmpleado}/pagos`);

// Abre la papeleta de pago en otra pestaña. La ventana se abre al instante (antes de pedir el PDF) para que el navegador no la bloquee.
export const abrirPapeletaPdf = async (idPago) => {
  const ventana = window.open("", "_blank");
  if (ventana) {
    ventana.opener = null;
    ventana.document.body.innerHTML = '<div style="font-family:Arial,sans-serif;padding:24px;color:#334155">Generando papeleta...</div>';
  }
  try {
    const { data } = await axios.get(`/api/planillas/pagos/${idPago}/pdf`, { responseType: "blob" });
    const url = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
    if (ventana) ventana.location.replace(url);
    else window.open(url, "_blank");
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    if (ventana) ventana.close();
    throw e;
  }
};

export const dinero = (n) => Number(n || 0).toLocaleString("es-BO", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
